import { Link } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import { GoogleReviews } from '../../components/feature/GoogleReviews';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
        <div 
          className="absolute inset-0 z-0"
          style={{
            backgroundImage: 'url(https://public.readdy.ai/ai/img_res/0a4fa9e72ed1d6aa9dd862347b8db03e.jpg)',
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-gray-900/70 via-gray-900/50 to-gray-900/70 z-0"></div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 text-center">
          <h1 className="text-5xl md:text-7xl font-extrabold text-white mb-6 leading-tight">
            Empieza hoy a pagar menos por tu luz y tu gas
          </h1>
          
          <p className="text-2xl md:text-3xl text-white/90 font-light mb-12">
            Más del 80% de las personas paga de más sin saberlo.<br />
            Te decimos cuánto puedes ahorrar en menos de 24 h.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
            <Link 
              to="/subir-factura"
              className="inline-flex items-center justify-center gap-3 bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white font-bold px-8 py-5 rounded-full text-lg transition-all transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
            >
              🔥 Enviar mi factura ahora
            </Link>
            
            <Link 
              to="/calculadora"
              className="inline-flex items-center justify-center gap-3 bg-white/10 backdrop-blur-sm hover:bg-white/20 text-white font-semibold px-8 py-5 rounded-full text-lg border-2 border-white/30 transition-all whitespace-nowrap cursor-pointer"
            >
              ⚡ Calcular mi ahorro
            </Link>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
            <Link 
              to="/empresas"
              className="inline-flex items-center justify-center gap-3 bg-white/10 backdrop-blur-sm hover:bg-white/20 text-white font-semibold px-8 py-5 rounded-full text-lg border-2 border-white/30 transition-all whitespace-nowrap cursor-pointer"
            >
              🏢 Soy empresa
            </Link>
            
            <Link 
              to="/solar"
              className="inline-flex items-center justify-center gap-3 bg-white/10 backdrop-blur-sm hover:bg-white/20 text-white font-semibold px-8 py-5 rounded-full text-lg border-2 border-white/30 transition-all whitespace-nowrap cursor-pointer"
            >
              ☀️ Energía solar y batería virtual
            </Link>
          </div>

          {/* Trust Badges */}
          <div className="max-w-4xl mx-auto bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
              <div className="flex items-center gap-3 justify-center">
                <i className="ri-check-line text-2xl text-green-400"></i>
                <span className="text-white font-medium">Gestión gratuita</span>
              </div>
              <div className="flex items-center gap-3 justify-center">
                <i className="ri-check-line text-2xl text-green-400"></i>
                <span className="text-white font-medium">Sin permanencia</span>
              </div>
              <div className="flex items-center gap-3 justify-center">
                <i className="ri-check-line text-2xl text-green-400"></i>
                <span className="text-white font-medium">Respuesta &lt;24h</span>
              </div>
              <div className="flex items-center gap-3 justify-center">
                <i className="ri-check-line text-2xl text-green-400"></i>
                <span className="text-white font-medium">Asesor personal</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Google Reviews - After Trust Badges */}
      <GoogleReviews maxReviews={6} />

      {/* Cómo funciona */}
      <section className="py-24 px-4 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <span className="inline-block text-sm font-semibold text-[#0A5FFF] bg-blue-50 px-4 py-2 rounded-full mb-4">
              Proceso simple
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-[#1F2937] mb-4">
              Cómo funciona
            </h2>
            <p className="text-xl text-gray-600">
              En 3 pasos sencillos empiezas a ahorrar
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-[#F7F9FC] rounded-3xl p-8 text-center">
              <div className="w-16 h-16 bg-[#0A5FFF] rounded-full flex items-center justify-center mx-auto mb-6">
                <span className="text-white font-bold text-2xl">1</span>
              </div>
              <h3 className="text-2xl font-bold text-[#1F2937] mb-4">Sube tu factura</h3>
              <p className="text-gray-600">
                Envíanos tu factura actual de luz o gas en foto o PDF. Es rápido y seguro.
              </p>
            </div>

            <div className="bg-[#F7F9FC] rounded-3xl p-8 text-center">
              <div className="w-16 h-16 bg-[#00C853] rounded-full flex items-center justify-center mx-auto mb-6">
                <span className="text-white font-bold text-2xl">2</span>
              </div>
              <h3 className="text-2xl font-bold text-[#1F2937] mb-4">La analizamos</h3>
              <p className="text-gray-600">
                Nuestro equipo revisa tu factura y compara con todas las tarifas del mercado.
              </p>
            </div>

            <div className="bg-[#F7F9FC] rounded-3xl p-8 text-center">
              <div className="w-16 h-16 bg-[#FF8F00] rounded-full flex items-center justify-center mx-auto mb-6">
                <span className="text-white font-bold text-2xl">3</span>
              </div>
              <h3 className="text-2xl font-bold text-[#1F2937] mb-4">Te enviamos la mejor propuesta</h3>
              <p className="text-gray-600">
                Recibes tu análisis personalizado con el ahorro exacto que puedes conseguir.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Garantía de honestidad */}
      <section className="py-24 px-4 bg-gradient-to-br from-[#00C853]/10 to-[#0A5FFF]/10">
        <div className="max-w-4xl mx-auto text-center">
          <div className="bg-white rounded-3xl p-12 shadow-lg">
            <div className="w-20 h-20 bg-[#00C853] rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-shield-check-line text-white text-4xl"></i>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-[#1F2937] mb-6">
              Garantía de honestidad
            </h2>
            <p className="text-xl text-gray-700 leading-relaxed">
              Si no podemos mejorar tu factura, te lo diremos claramente. No hacemos promesas falsas. Nuestro compromiso es con tu ahorro real, no con venderte algo que no necesitas.
            </p>
          </div>
        </div>
      </section>

      {/* Opiniones */}
      <section className="py-24 px-4 bg-white">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-[#1F2937] mb-4">
              Lo que dicen nuestros clientes
            </h2>
            <div className="inline-flex items-center gap-2 bg-[#1F2937] text-white px-4 py-2 rounded-lg">
              <i className="ri-star-fill text-yellow-400"></i>
              <span className="font-bold">4.9/5</span>
            </div>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-[#F7F9FC] rounded-3xl p-8">
              <div className="flex items-center gap-2 mb-4">
                <i className="ri-star-fill text-yellow-400"></i>
                <i className="ri-star-fill text-yellow-400"></i>
                <i className="ri-star-fill text-yellow-400"></i>
                <i className="ri-star-fill text-yellow-400"></i>
                <i className="ri-star-fill text-yellow-400"></i>
              </div>
              <p className="text-gray-700 mb-6 italic">
                "He bajado 22€/mes en mi factura. El proceso fue súper rápido y me mantuvieron informada todo el tiempo."
              </p>
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-[#00C853] rounded-full flex items-center justify-center">
                  <span className="text-white font-bold">MC</span>
                </div>
                <div>
                  <p className="font-bold text-[#1F2937]">María Carmen R.</p>
                  <p className="text-sm text-gray-600">Granada</p>
                </div>
              </div>
            </div>

            <div className="bg-[#F7F9FC] rounded-3xl p-8">
              <div className="flex items-center gap-2 mb-4">
                <i className="ri-star-fill text-yellow-400"></i>
                <i className="ri-star-fill text-yellow-400"></i>
                <i className="ri-star-fill text-yellow-400"></i>
                <i className="ri-star-fill text-yellow-400"></i>
                <i className="ri-star-fill text-yellow-400"></i>
              </div>
              <p className="text-gray-700 mb-6 italic">
                "Servicio rápido y profesional. Me ayudaron a entender mi factura y ahora pago mucho menos."
              </p>
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-[#0A5FFF] rounded-full flex items-center justify-center">
                  <span className="text-white font-bold">JL</span>
                </div>
                <div>
                  <p className="font-bold text-[#1F2937]">José Luis M.</p>
                  <p className="text-sm text-gray-600">Málaga</p>
                </div>
              </div>
            </div>

            <div className="bg-[#F7F9FC] rounded-3xl p-8">
              <div className="flex items-center gap-2 mb-4">
                <i className="ri-star-fill text-yellow-400"></i>
                <i className="ri-star-fill text-yellow-400"></i>
                <i className="ri-star-fill text-yellow-400"></i>
                <i className="ri-star-fill text-yellow-400"></i>
                <i className="ri-star-fill text-yellow-400"></i>
              </div>
              <p className="text-gray-700 mb-6 italic">
                "Me lo gestionaron todo sin que yo tuviera que hacer nada. Totalmente recomendable."
              </p>
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-[#FF8F00] rounded-full flex items-center justify-center">
                  <span className="text-white font-bold">AP</span>
                </div>
                <div>
                  <p className="font-bold text-[#1F2937]">Ana P.</p>
                  <p className="text-sm text-gray-600">Sevilla</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Final */}
      <section className="py-24 px-4 bg-gradient-to-br from-[#0A5FFF] to-[#00C853]">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            ¿Listo para empezar a ahorrar?
          </h2>
          <p className="text-xl text-white/90 mb-8">
            Te revisamos hoy mismo. En menos de 24h te damos respuesta.
          </p>
          <Link
            to="/subir-factura"
            className="inline-flex items-center justify-center gap-3 bg-[#FF8F00] hover:bg-[#E68000] text-white font-bold px-10 py-5 rounded-full text-xl transition-all transform hover:scale-105 shadow-2xl whitespace-nowrap cursor-pointer"
          >
            Enviar factura ahora
          </Link>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-24 px-4 bg-gray-50">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-2 gap-12 mb-16">
            <div>
              <h2 className="text-5xl md:text-6xl font-bold text-gray-900 leading-tight">
                Ahorro sin<br />complicaciones
              </h2>
            </div>
            <div className="flex items-center">
              <p className="text-xl text-gray-600 leading-relaxed">
                Trabajamos con todas las tarifas del mercado para encontrar la mejor opción para tu hogar o negocio. Sin costes ocultos.
              </p>
            </div>
          </div>

          <div className="grid md:grid-cols-3 gap-6">
            <div className="md:col-span-1 bg-white rounded-3xl p-8 shadow-sm hover:shadow-md transition-shadow">
              <div className="mb-6">
                <img 
                  src="https://readdy.ai/api/search-image?query=Minimalist%20isometric%20illustration%20of%20electricity%20bill%20invoice%20document%20with%20green%20checkmark%20approval%20symbol%20clean%20simple%20design%20flat%20colors%20modern%20vector%20style%20energy%20savings%20concept%20white%20background%20professional%20business%20graphic&width=400&height=300&seq=feat001&orientation=landscape"
                  alt="Sin permanencia"
                  className="w-full h-48 object-cover rounded-2xl"
                />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">Sin permanencia</h3>
              <p className="text-gray-600">Cambia cuando quieras sin penalizaciones ni ataduras</p>
            </div>

            <div className="md:col-span-1 bg-white rounded-3xl p-8 shadow-sm hover:shadow-md transition-shadow">
              <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">Gestión gratuita</h3>
              <div className="mb-6">
                <img 
                  src="https://readdy.ai/api/search-image?query=Minimalist%20calculator%20icon%20illustration%20on%20dark%20emerald%20green%20background%20simple%20clean%20design%20modern%20flat%20style%20financial%20calculation%20symbol%20professional%20business%20graphic%20geometric%20shapes%20vector%20art%20energy%20cost%20savings%20concept&width=400&height=300&seq=feat002&orientation=landscape"
                  alt="Gestión gratuita"
                  className="w-full h-48 object-cover rounded-2xl"
                />
              </div>
              <p className="text-gray-600 text-center">Nos encargamos de todo sin coste adicional para ti</p>
            </div>

            <div className="md:col-span-1 bg-white rounded-3xl p-8 shadow-sm hover:shadow-md transition-shadow">
              <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">Ahorros inmediatos</h3>
              <div className="mb-6">
                <img 
                  src="https://readdy.ai/api/search-image?query=Stylized%20descending%20bar%20chart%20graph%20showing%20decreasing%20costs%20savings%20trend%20minimalist%20design%20green%20and%20white%20colors%20modern%20flat%20illustration%20financial%20reduction%20concept%20clean%20simple%20vector%20style%20energy%20bill%20reduction%20visualization&width=400&height=300&seq=feat003&orientation=landscape"
                  alt="Ahorros inmediatos"
                  className="w-full h-48 object-cover rounded-2xl"
                />
              </div>
              <p className="text-gray-600 text-center">Empieza a ahorrar desde tu próxima factura</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Upload Section */}
      <section className="relative min-h-[80vh] flex items-center justify-center overflow-hidden">
        <div 
          className="absolute inset-0 z-0"
          style={{
            backgroundImage: 'url(https://readdy.ai/api/search-image?query=Modern%20solar%20panels%20array%20installation%20on%20rooftop%20against%20bright%20clear%20blue%20sky%20renewable%20clean%20energy%20technology%20photovoltaic%20system%20sustainable%20power%20generation%20sunny%20day%20environmental%20conservation%20green%20energy%20solution%20wide%20angle%20view&width=1920&height=1080&seq=cta001&orientation=landscape)',
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-gray-900/30 to-gray-900/60 z-0"></div>

        <div className="relative z-10 text-center px-4 max-w-4xl mx-auto">
          <h2 className="text-5xl md:text-7xl font-bold text-white mb-8 tracking-wide">
            DESCUBRE TU AHORRO
          </h2>
          
          <div className="space-y-3 mb-10">
            <p className="text-2xl text-white font-light">
              Sube tu factura en PDF o foto
            </p>
            <p className="text-2xl text-white font-light">
              Te respondemos en menos de 24 horas
            </p>
          </div>

          <Link 
            to="/subir-factura"
            className="inline-flex items-center gap-4 bg-gray-900 hover:bg-gray-800 text-white font-bold px-10 py-5 rounded-full text-xl transition-all transform hover:scale-105 shadow-2xl whitespace-nowrap cursor-pointer"
          >
            <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center">
              <i className="ri-upload-cloud-line text-2xl text-white"></i>
            </div>
            SUBIR FACTURA
            <i className="ri-arrow-right-up-line text-2xl"></i>
          </Link>
        </div>
      </section>

      {/* Calculator Section */}
      <section id="calculadora" className="py-24 px-4 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-5 gap-12 items-center">
            <div className="md:col-span-3 space-y-6">
              <span className="inline-block text-sm font-semibold text-emerald-600 bg-emerald-50 px-4 py-2 rounded-full">
                Calculadora instantánea
              </span>
              
              <h2 className="text-5xl md:text-7xl font-light text-gray-900 leading-tight">
                Calcula tu ahorro
                <br />
                <span className="font-bold">en 30 segundos</span>
              </h2>

              <p className="text-xl text-gray-600">
                Introduce tus datos y descubre cuánto podrías estar ahorrando cada mes en tu factura energética.
              </p>
            </div>

            <div className="md:col-span-2">
              <div className="bg-gray-50 rounded-3xl p-8 shadow-lg">
                <form 
                  action="https://readdy.ai/api/form/d57e1uu9uelhi9993ang"
                  method="POST"
                  data-readdy-form
                  className="space-y-6"
                  onSubmit={(e) => {
                    e.preventDefault();
                    const form = e.currentTarget;
                    const formData = new FormData(form);
                    
                    fetch('https://readdy.ai/api/form/d57e1uu9uelhi9993ang', {
                      method: 'POST',
                      headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                      },
                      body: new URLSearchParams(formData as any).toString()
                    }).then(() => {
                      alert('¡Gracias! Te contactaremos pronto con tu estimación de ahorro.');
                      form.reset();
                    }).catch(() => {
                      alert('Hubo un error. Por favor, inténtalo de nuevo.');
                    });
                  }}
                >
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Compañía actual (opcional)
                    </label>
                    <input
                      type="text"
                      name="compania"
                      className="w-full px-4 py-3 border-b-2 border-gray-300 focus:border-emerald-500 bg-transparent outline-none transition-colors"
                      placeholder="Ej: Endesa, Iberdrola..."
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Potencia contratada (kW) *
                    </label>
                    <input
                      type="number"
                      name="potencia"
                      step="0.1"
                      required
                      className="w-full px-4 py-3 border-b-2 border-gray-300 focus:border-emerald-500 bg-transparent outline-none transition-colors"
                      placeholder="Ej: 4.6"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Consumo mensual (kWh) *
                    </label>
                    <input
                      type="number"
                      name="consumo"
                      required
                      className="w-full px-4 py-3 border-b-2 border-gray-300 focus:border-emerald-500 bg-transparent outline-none transition-colors"
                      placeholder="Ej: 250"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Provincia *
                    </label>
                    <select
                      name="provincia"
                      required
                      className="w-full px-4 py-3 border-b-2 border-gray-300 focus:border-emerald-500 bg-transparent outline-none transition-colors cursor-pointer"
                    >
                      <option value="Granada">Granada</option>
                      <option value="Madrid">Madrid</option>
                      <option value="Barcelona">Barcelona</option>
                      <option value="Valencia">Valencia</option>
                      <option value="Sevilla">Sevilla</option>
                      <option value="Málaga">Málaga</option>
                      <option value="Otra">Otra</option>
                    </select>
                  </div>

                  <button
                    type="submit"
                    className="w-full bg-emerald-500 hover:bg-emerald-600 text-gray-900 font-bold py-4 rounded-full text-lg transition-all transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
                  >
                    VER MI AHORRO
                  </button>

                  <p className="text-xs text-gray-500 text-center">
                    * Estimación orientativa. Te contactaremos para confirmar el ahorro exacto.
                  </p>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Trust Section */}
      <section className="py-24 px-4 bg-gradient-to-br from-amber-50 via-orange-50 to-yellow-50">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-5 gap-12 items-center">
            <div className="md:col-span-3 space-y-8">
              <span className="inline-block text-sm font-semibold text-emerald-700 bg-white/60 px-4 py-2 rounded-full">
                Por qué confiar en nosotros
              </span>

              <h2 className="text-5xl md:text-7xl font-extralight text-emerald-900 leading-tight">
                Trabajamos con todas<br />
                <span className="font-bold">las tarifas del mercado</span><br />
                para encontrar la mejor<br />
                <span className="font-bold">para ti</span>
              </h2>

              <p className="text-xl text-gray-700 leading-relaxed">
                Analizamos cientos de opciones de las principales comercializadoras para garantizar que obtengas el mejor precio y las condiciones más favorables.
              </p>

              <div className="flex flex-col sm:flex-row gap-4 pt-4">
                <Link
                  to="/subir-factura"
                  className="inline-flex items-center justify-center gap-2 bg-emerald-800 hover:bg-emerald-900 text-white font-bold px-8 py-4 rounded-full text-lg transition-all whitespace-nowrap cursor-pointer"
                >
                  QUIERO UNA REVISIÓN GRATUITA
                </Link>
              </div>
            </div>

            <div className="md:col-span-2">
              <div className="bg-white rounded-3xl p-8 shadow-lg space-y-6">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-emerald-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-shield-check-line text-2xl text-emerald-600"></i>
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-900 mb-2">100% Transparente</h3>
                    <p className="text-gray-600 text-sm">Sin comisiones ocultas ni sorpresas en tu factura</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-time-line text-2xl text-teal-600"></i>
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-900 mb-2">Respuesta en 24h</h3>
                    <p className="text-gray-600 text-sm">Analizamos tu caso y te enviamos una propuesta personalizada</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-customer-service-2-line text-2xl text-green-600"></i>
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-900 mb-2">Soporte continuo</h3>
                    <p className="text-gray-600 text-sm">Te acompañamos durante todo el proceso y después del cambio</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Business Section */}
      <section className="py-24 px-4 bg-gradient-to-br from-gray-900 via-teal-900 to-emerald-900">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="text-white space-y-8">
              <h2 className="text-4xl md:text-5xl font-bold">
                Soluciones para empresas
              </h2>
              
              <p className="text-xl text-white/90">
                Optimiza los costes energéticos de tu negocio con tarifas especiales adaptadas a tu sector y horarios de consumo.
              </p>

              <div className="space-y-4">
                <div className="flex items-center gap-3">
                  <div className="w-6 h-6 bg-emerald-500 rounded flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <span className="text-lg">Restaurantes y hostelería</span>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-6 h-6 bg-emerald-500 rounded flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <span className="text-lg">Hoteles y alojamientos</span>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-6 h-6 bg-emerald-500 rounded flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <span className="text-lg">Talleres y comercios</span>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-6 h-6 bg-emerald-500 rounded flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <span className="text-lg">Oficinas y coworkings</span>
                </div>
              </div>

              <a
                href="https://wa.me/34600000000?text=Hola,%20necesito%20información%20sobre%20tarifas%20para%20empresas"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-3 bg-green-500 hover:bg-green-600 text-white font-bold px-8 py-4 rounded-full text-lg transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line text-2xl"></i>
                CONTACTAR POR WHATSAPP
              </a>
            </div>

            <div className="bg-white rounded-3xl p-8 shadow-2xl">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">
                Solicita tu estudio personalizado
              </h3>
              
              <form 
                action="https://readdy.ai/api/form/d57e1uu9uelhi9993ao0"
                method="POST"
                data-readdy-form
                className="space-y-5"
                onSubmit={(e) => {
                  e.preventDefault();
                  const form = e.currentTarget;
                  const formData = new FormData(form);
                  
                  fetch('https://readdy.ai/api/form/d57e1uu9uelhi9993ao0', {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    body: new URLSearchParams(formData as any).toString()
                  }).then(() => {
                    alert('¡Solicitud recibida! Nos pondremos en contacto contigo pronto.');
                    form.reset();
                  }).catch(() => {
                    alert('Hubo un error. Por favor, inténtalo de nuevo.');
                  });
                }}
              >
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Nombre de la empresa *
                  </label>
                  <input
                    type="text"
                    name="empresa"
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-transparent outline-none"
                    placeholder="Tu empresa"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Tipo de negocio *
                  </label>
                  <select
                    name="tipo_negocio"
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-transparent outline-none cursor-pointer"
                  >
                    <option value="">Selecciona una opción</option>
                    <option value="Restaurante">Restaurante</option>
                    <option value="Hotel">Hotel</option>
                    <option value="Taller">Taller</option>
                    <option value="Oficina">Oficina</option>
                    <option value="Comercio">Comercio</option>
                    <option value="Otro">Otro</option>
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Horario de consumo *
                  </label>
                  <div className="space-y-2">
                    <label className="flex items-center gap-2 cursor-pointer">
                      <input type="radio" name="horario" value="Diurno" required className="cursor-pointer" />
                      <span>Diurno (principalmente de día)</span>
                    </label>
                    <label className="flex items-center gap-2 cursor-pointer">
                      <input type="radio" name="horario" value="Nocturno" required className="cursor-pointer" />
                      <span>Nocturno (principalmente de noche)</span>
                    </label>
                    <label className="flex items-center gap-2 cursor-pointer">
                      <input type="radio" name="horario" value="Mixto" required className="cursor-pointer" />
                      <span>Mixto (día y noche)</span>
                    </label>
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Número de suministros *
                  </label>
                  <input
                    type="number"
                    name="suministros"
                    min="1"
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-transparent outline-none"
                    placeholder="1"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Teléfono de contacto *
                  </label>
                  <input
                    type="tel"
                    name="telefono"
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-transparent outline-none"
                    placeholder="600 000 000"
                  />
                </div>

                <button
                  type="submit"
                  className="w-full bg-emerald-600 hover:bg-emerald-700 text-white font-bold py-4 rounded-lg transition-all whitespace-nowrap cursor-pointer"
                >
                  SOLICITAR ESTUDIO
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      <Footer />

      {/* WhatsApp Sticky Button */}
      <a
        href="https://wa.me/34696237625?text=Hola,%20quiero%20ahorrar%20en%20mi%20factura.%20¿Podéis%20revisarla?"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-24 right-6 z-40 w-16 h-16 bg-[#25D366] hover:bg-[#20BA5A] text-white rounded-full flex items-center justify-center shadow-2xl transition-all hover:scale-110 cursor-pointer"
        title="WhatsApp"
      >
        <i className="ri-whatsapp-line text-3xl"></i>
      </a>
    </div>
  );
}